<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">


      <div class="grid-menu grid-menu-2col">
        <div class="no-gutters row">

<!--          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="purchase-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>-->

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('purchase-supplier')"
                      to="purchase-supplier">
              <i class="lnr-apartment btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Fornecedores
            </t-button>
          </div>


        </div>
      </div>

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'PurchaseSetting',
  data() {
    return {

    }
  },
  methods: {

    mountedPrepare(){


    },
    async mountedContinued(){

    }
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
